module.exports = __webpack_public_path__ + "assets/ic_tree03.ad826ed8.svg";